/* eslint camelcase: 0 */
import Vue from 'vue'
import Vuetify from 'vuetify'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import auth from './auth/auth.js'
import App from 'components/app-root'
import SiteDown from './components/site-down'
import CustomComponents from './modules/custom-components'
import CustomFilters from './modules/custom-filters'
import ConfirmModule from './modules/confirm'
import SnackbarModule from './modules/snackbar'
import AlertModule from './modules/alert'
import { addStartHook, addEndHook } from '$app/auth/auth-session.js'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';
import ApiConnection from './plugins/api-connection';
import getConfigs from './configs'

Vue.prototype.$http = ApiConnection;

addStartHook(() => store.dispatch('processingQueue/connect'));
addEndHook(() => store.dispatch('processingQueue/disconnect'));

store.dispatch('search/reset');

Vue.directive('nt', {
  bind: function (el) {
    el.classList.add('notranslate')
  }
})

Vue.use(Vuetify)
Vue.use(ConfirmModule)
Vue.use(SnackbarModule)
Vue.use(AlertModule)
Vue.use(CustomFilters)
Vue.use(CustomComponents)

getConfigs().then((configs) => {
  Vue.prototype.$configs = {
    drawerBreakpoint: 1430,
    ...configs
  }
});

Vue.prototype.$auth = auth.checkAuth
Vue.prototype.$logout = auth.logout
Vue.prototype.$roles = auth.roles

sync(store, router)

router.beforeEach(auth.checkRoute)
router.afterEach(auth.checkCookie)

if (window.vpkUser && window.vpkUser.name != null) {
  store.dispatch('user/setUser', window.vpkUser);
}

const app = new Vue({
  store,
  router,
  ...App
});

const siteDown = new Vue({ render: h => h(SiteDown) });

export {
  app,
  router,
  store,
  siteDown
}
